var youbora = require('youboralib')
var manifest = require('../../manifest.json')

var BrightcoveAdsAdapter = youbora.Adapter.extend({
  getVersion: function () {
    return manifest.version + '-videojs-bcove-ads'
  },

  getPlayhead: function () {
    return this.player.ima3.adPlayer.currentTime()
  },

  registerListeners: function () {
    // Console all events if logLevel=DEBUG
    youbora.Util.logAllEvents(this.player, [
      null,
      'ima3-ready',
      'ima3error',
      'ima3-ad-error',
      'ima3-started',
      'ima3-complete',
      'ima3-paused',
      'ima3-resumed',
      'ads-request',
      'ads-load',
      'ads-ad-started',
      'ads-ad-ended',
      'ads-pause',
      'ads-play',
      'ads-click',
      'ads-pod-started',
      'ads-pod-ended',
      'ads-allpods-completed'
    ])

    // Enable playhead monitor
    this.monitorPlayhead(true, false)

    // Register listeners
    this.player.on('ima3-started', this.imaStartedListener.bind(this))
    this.player.on('ima3-paused', this.imaPausedListener.bind(this))
    this.player.on('ima3-resumed', this.imaResumedListener.bind(this))
    this.player.on('ima3-complete', this.imaCompleteListener.bind(this))
    this.player.on('ima3-skipped', this.imaSkippedListener.bind(this))
    this.player.on('adserror', this.errorListener.bind(this))
    this.player.on('ads-click', this.clickListener.bind(this))
  },

  imaStartedListener: function (e) {
    this.fireStart()
    this.fireJoin()
  },

  imaPausedListener: function (e) {
    this.firePause()
  },

  imaResumedListener: function (e) {
    this.fireResume()
  },

  imaCompleteListener: function (e) {
    this.fireStop()
  },

  imaSkippedListener: function (e) {
    this.fireStop({ skipped: true })
  },

  errorListener: function (e) {
    this.fireError('Ad error')
  },

  clickListener: function (e) {
    this.fireClick()
  },

  unregisterListeners: function () {
    // Disable playhead monitoring
    this.monitor.stop()

    // unregister listeners
    this.player.off('ima3-started', this.imaStartedListener)
    this.player.off('ima3-paused', this.imaPausedListener)
    this.player.off('ima3-resumed', this.imaResumedListener)
    this.player.off('ima3-complete', this.imaCompleteListener)
    this.player.off('ima3-skipped', this.imaSkippedListener)
    this.player.off('adserror', this.errorListener)
    this.player.off('ads-click', this.clickListener)
  }
},
  // Static Members
  {
    isUsed: function (plugin) {
      return plugin.player.ima || plugin.player.ima3
    }
  }
)

module.exports = BrightcoveAdsAdapter



//////////////////
// WEBPACK FOOTER
// ./src/ads/brightcove-ads.js
// module id = 60
// module chunks = 0